// @flow
import React from 'react'
import { Link } from 'react-router-dom'
import config from 'client/config'

const LoadError = (): any => <div className='login'>
  <span className='login__accent' />
  <div className='login__header'>
    <h3 className='login__title'>Failed to load page</h3>
    <h4 className='login__subtitle'>A report has been sent to the Winmore team. If this issue persists, please contact us at <a className='login__inline-link' href={`mailto:${config.supportEmail}`}>{config.supportEmail}</a> or reach out through Help & Feedback in the main menu.</h4>
  </div>
  <Link to='/' className='login__link'>Return to Login Page</Link>
</div>

export default LoadError
